import * as React from 'react'
import { MailRegular } from '@fluentui/react-icons'
import { Button, ButtonProps, Tooltip } from '@fluentui/react-components'

type PhoneNumberButtonProps = Required<Pick<ButtonProps, 'onClick'>> & {
    textValue?: string
    withTooltip?: boolean
    tooltipValue?: string
    buttonProps?: ButtonProps
}

export default function EmailButton(props: PhoneNumberButtonProps) {
    const button = (
        <Button
            size="small"
            appearance={'subtle'}
            icon={<MailRegular />}
            {...props.buttonProps}
            onClick={e => {
                e.stopPropagation()
                props.onClick(e)
            }}
        >
            {props.textValue}
        </Button>
    )

    if (props.withTooltip) {
        return (
            <Tooltip relationship={'description'} content={props.tooltipValue ?? props.textValue} withArrow>
                {button}
            </Tooltip>
        )
    }

    return button
}
